.attention {
  display: flex;
  gap: 0.5rem;
}

.attention > svg {
  flex-shrink: 0;
  height: 1.5rem;
  width: 1.5rem;
}
